<template>
  <input
    type="file"
    ref="xmlFile"
    class="form-control"
    accept="text/xml"
    @click="cleanInputFile"
    @change="loadTextFromFile"
  />
</template>

<script>
export default {
  name: 'XmlInput',

  methods: {
    cleanInputFile() {
      this.$refs.xmlFile.value = null
    },

    loadTextFromFile(ev) {
      const file = ev.target.files[0]
      const reader = new FileReader()
      reader.onload = (e) => this.$emit('load', e.target.result)
      reader.readAsText(file)
    },
  },
}
</script>
